import { render, staticRenderFns } from "./WithdrawalConfirmModal.vue?vue&type=template&id=21d0cd05&"
import script from "./WithdrawalConfirmModal.vue?vue&type=script&lang=js&"
export * from "./WithdrawalConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports